

const XRAY_ANIMATION_NAME = 'xray_on';

let powerViewerSdk = null;
let onViewerLoadedCallback = null;

function fparshopPowerViewer() {
    const isMobile = window.innerWidth < 768;

    const activeWrapper = isMobile
        ? document.querySelector(".power-viewer-mobile-wrapper")
        : document.querySelector(".power-viewer-desktop-only");

    if (!activeWrapper) return;

    const q = (pvId) => activeWrapper.querySelector(`[data-pv-id="${pvId}"]`);

    const els = {
        productColumnMiddle: document.getElementById("productColumnMiddle"),
        mobileWrapper: document.querySelector(".power-viewer-mobile-wrapper"),
        productViewer: q("productViewer"),
        toggleButton: q("powerViewerOpenButton"),
        controls: q("powerViewerControls"),
        loader: q("powerViewerLoaderCont"),
        xrayButton: q("powerViewerXrayButton")
    };

    if (!els.productViewer || !els.controls || !els.toggleButton) return;

    const htmlClass = {
        isHidden: "hidden",
        isOpen: "is-open",
        isVisible: "is-visible",
        isActive: "is-active"
    };

    const texts = {
        opened: els.toggleButton.dataset.textOpened,
        closed: els.toggleButton.dataset.textClosed,
    };

    const xrayTexts = {
        default: els.xrayButton?.dataset.textDefault,
        active: els.xrayButton?.dataset.textActive,
    };

    const xrayLabels = {
        default: els.xrayButton?.dataset.labelDefault,
        active: els.xrayButton?.dataset.labelActive,
    };

    const ariaLabels = {
        opened: els.toggleButton.dataset.labelOpened,
        closed: els.toggleButton.dataset.labelClosed
    };

    const skus = {
        closed: els.controls.dataset.skuClosed,
        opened: els.controls.dataset.skuOpened,
    };

    let isOpened = false;
    let isXrayActive = false;

    const setAttribute = (el, attr, value) => () => el.setAttribute(attr, value);
    const toggleClass = (el, className, force) => () => el.classList.toggle(className, force);
    const setText = (el, text) => () => (el.textContent = text);
    const addEvent = (el, event, fn) => el?.addEventListener(event, fn);

    let currentSku = skus.closed;
    let loaderFallbackTimer = null;

    const hideLoader = () => {
        els.loader?.classList.remove(htmlClass.isVisible);
    };

    const showLoader = () => {
        els.loader?.classList.add(htmlClass.isVisible);
    };

    const scheduleLoaderFallback = () => {
        clearTimeout(loaderFallbackTimer);
        loaderFallbackTimer = setTimeout(hideLoader, 3000);
    };

    onViewerLoadedCallback = () => {
        clearTimeout(loaderFallbackTimer);
        hideLoader();
        updateXrayUi();
    };

    const updateXrayButton = () => {
        if (!els.xrayButton) return;

        setText(els.xrayButton, isXrayActive ? xrayTexts.active : xrayTexts.default)();
        setAttribute(
            els.xrayButton,
            "aria-label",
            isXrayActive ? xrayLabels.active : xrayLabels.default
        )();
    };

    const resetXrayUi = () => {
        if (!isXrayActive) return;

        isXrayActive = false;

        if (powerViewerSdk && currentSku === skus.opened) {
            powerViewerSdk.playProductAnimation(XRAY_ANIMATION_NAME, false, false);
        }

        updateXrayButton();
    };

    const updateXrayUi = () => {
        if (!els.xrayButton) return;

        toggleClass(els.xrayButton, htmlClass.isHidden, !isOpened)();
        toggleClass(els.controls, "no-content-view", !isOpened)();
        updateXrayButton();
    };

    const playXrayAnimation = (active) => {
        if (!powerViewerSdk || currentSku !== skus.opened) return;
        powerViewerSdk.playProductAnimation(XRAY_ANIMATION_NAME, active, false);
    };

    const initViewer = () => {
        currentSku = skus.closed;
        setAttribute(els.productViewer, "sku", skus.closed)();
        setAttribute(els.productViewer, "start", "eager")();
        toggleClass(els.toggleButton, htmlClass.isHidden, false)();
        showLoader();
        updateXrayUi();
    };

    const setSku = (sku) => {
        if (sku === currentSku) return;
        currentSku = sku;
        setAttribute(els.productViewer, "sku", sku)();
        showLoader();
        scheduleLoaderFallback();
    };

    const pushViewState = (viewState) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_3d_sku_change',
            sku: els.controls.dataset.shopifySku || '',
            view_state: viewState
        });
    };

    const handleToggleClick = () => {
        isOpened = !isOpened;

        if (!isOpened) {
            resetXrayUi();
        }

        setSku(isOpened ? skus.opened : skus.closed);
        setText(els.toggleButton, isOpened ? texts.closed : texts.opened)();
        setAttribute(els.toggleButton, "aria-label", isOpened ? ariaLabels.closed : ariaLabels.opened)();
        updateXrayUi();

        pushViewState(isOpened ? 'opened' : 'closed');
    };

    const handleXrayClick = () => {
        if (!isOpened || currentSku !== skus.opened || !powerViewerSdk) return;

        isXrayActive = !isXrayActive;
        playXrayAnimation(isXrayActive);
        updateXrayButton();
        pushViewState(isXrayActive ? 'xray' : 'opened');
    };

    if (isMobile && els.mobileWrapper) {
        els.mobileWrapper.classList.add(htmlClass.isActive);
    } else if (els.productColumnMiddle) {
        els.productColumnMiddle.classList.add(htmlClass.isOpen);
    }

    initViewer();

    addEvent(els.toggleButton, "click", handleToggleClick);

    if (els.xrayButton) {
        addEvent(els.xrayButton, "click", handleXrayClick);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 768;

    const inactiveWrapper = isMobile
        ? document.querySelector(".power-viewer-desktop-only")
        : document.querySelector(".power-viewer-mobile-wrapper");

    const inactiveViewer = inactiveWrapper?.querySelector("[data-pv-id='productViewer']");
    if (inactiveViewer) {
        inactiveViewer.setAttribute("start", "manual");
    }

    fparshopPowerViewer();

    if (typeof POWERViewer === 'undefined') return;

    const activeWrapper = isMobile
        ? document.querySelector(".power-viewer-mobile-wrapper")
        : document.querySelector(".power-viewer-desktop-only");

    if (!activeWrapper) return;

    const viewerEl = activeWrapper.querySelector("[data-pv-id='productViewer']");
    if (!viewerEl) return;

    powerViewerSdk = new POWERViewer({ id: viewerEl.id });

    const controls = activeWrapper.querySelector("[data-pv-id='powerViewerControls']");
    const shopifySku = controls?.dataset.shopifySku || '';

    powerViewerSdk.onLoad(() => {
        onViewerLoadedCallback?.();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_3d_product_loaded',
            sku: shopifySku
        });
    });
});
